import { render, staticRenderFns } from "./GameLobby.vue?vue&type=template&id=1e2c278c"
import script from "./GameLobby.vue?vue&type=script&lang=js"
export * from "./GameLobby.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2c278c')) {
      api.createRecord('1e2c278c', component.options)
    } else {
      api.reload('1e2c278c', component.options)
    }
    module.hot.accept("./GameLobby.vue?vue&type=template&id=1e2c278c", function () {
      api.rerender('1e2c278c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GameLobby.vue"
export default component.exports